import { render, staticRenderFns } from "./listVenom.vue?vue&type=template&id=54f0a716"
import script from "./listVenom.vue?vue&type=script&lang=js"
export * from "./listVenom.vue?vue&type=script&lang=js"
import style0 from "./listVenom.vue?vue&type=style&index=0&id=54f0a716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports